<p-overlayPanel
    #op
    [style]="{ 'min-width': '200px', padding: '-20px', margin: '-20px' }"
>
    <ng-template pTemplate>
        <div class="conn-grid" style="margin-top: 1px">
            <div></div>
            <button
                pButton
                pRipple
                type="button"
                label="Edit"
                class="p-button-text"
                [style]="{ width: '100%' }"
                icon="pi pi-pencil"
                iconPos="right"
                (click)="editButtonClicked()"
            ></button>
            <button
                pButton
                pRipple
                type="button"
                label="Delete"
                [style]="{ width: '100%' }"
                class="p-button-danger p-button-text"
                icon="pi pi-trash"
                iconPos="right"
                (click)="checkIfChannelUse()"
            ></button>
            <button
                pButton
                pRipple
                type="button"
                label="Assign Coupon"
                [style]="{ width: '100%' }"
                class="p-button-danger p-button-text"
                icon="pi pi-ticket"
                iconPos="right"
                (click)="assignCoupon(salesChannelServices.activeItem)"
            ></button>
        </div>
    </ng-template>
</p-overlayPanel>
<div class="conn-card">
    <app-report-top-filter-bar
        [paraReportName]="'sales-channel'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        (deleteItemFn)="optionDeleteClicked()"
    ></app-report-top-filter-bar>
    <br />
    <p-table
        #dt
        [tableStyle]="{ width: 'max-content' }"
        [value]="dataList"
        *ngIf="dataList?.length > 0"
        [autoLayout]="true"
        responsiveLayout="scroll"
        [paginator]="false"
        [rows]="rows"
        [customSort]="true"
        (onLazyLoad)="customSort($event)"
        [lazy]="true"
        showLoader="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} discounts"
        [globalFilterFields]="['fullName']"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        selectionMode="single"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <th style="text-align: center">#</th>
                <th style="text-align: center">Channel Name</th>
                <th pSortableColumn="status" style="text-align: center">
                    Status<p-sortIcon field="status"></p-sortIcon>
                </th>
                <th style="text-align: center">Coupons</th>
                <th style="text-align: center">Action</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" class="text-center">
                <td style="text-align: center">{{ item.index }}</td>
                <td style="text-align: center">{{ item.fullName }}</td>
                <td style="text-align: center">
                    <span
                        [ngClass]="{
                            enable: item.status,
                            disable: !item.status
                        }"
                        class="status-badge"
                    >
                        {{ item.status ? "Enable" : "Disable" }}
                    </span>
                </td>
                <td>
                    <div class="coupon-badges">
                        <ng-container
                            *ngIf="
                                item.salesChannelCoupon &&
                                item.salesChannelCoupon.length
                            "
                        >
                            <span
                                class="coupon-tag"
                                *ngFor="
                                    let c of item.salesChannelCoupon
                                        | slice : 0 : 1
                                "
                                >{{ c.couponCode }}</span
                            >
                            <span
                                *ngIf="item.salesChannelCoupon.length > 1"
                                class="coupon-tag more cursor-pointer"
                                (click)="showAllCoupons(item, $event)"
                            >
                                +{{ item.salesChannelCoupon.length - 1 }} more
                            </span>
                        </ng-container>
                        <span
                            *ngIf="!item.salesChannelCoupon?.length"
                            class="no-coupons"
                            >—</span
                        >
                    </div>
                </td>
                <td style="text-align: center">
                    <button
                        pButton
                        pRipple
                        icon="pi pi-angle-down"
                        iconPos="right"
                        type="button"
                        label="Actions"
                        class="n-action-button"
                        (click)="op.toggle($event)"
                        (click)="actionButtonClick(item)"
                    ></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="flex" *ngIf="dataList?.length == 0">
        <div class="text-align-center" style="width: 100%">
            <span class="control-description text-muted text-align-center">
                No data found!</span
            >
        </div>
    </div>
    <div>
        <p-paginator
            #p
            [first]="first"
            *ngIf="dataList?.length"
            (onPageChange)="onPageChange($event)"
            [rows]="rows"
            [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Records: {first} of {last}, Total Records: {totalRecords}"
        >
        </p-paginator>
    </div>
</div>

<p-dialog
    *ngIf="salesChannelServices.showEditChannel"
    header="Edit Channel"
    [(visible)]="salesChannelServices.showEditChannel"
    [style]="{ width: '40%' }"
    modal="true"
>
    <app-bizz-sales-channel-form
        [isNew]="false"
        [isViewOnly]="isViewOnly"
        (onSubmit)="refrestDataList($event)"
    ></app-bizz-sales-channel-form>
</p-dialog>
<ng-container *ngIf="salesChannelServices.showNewEditChannel">
    <p-dialog
        header="Add a New Channel"
        [(visible)]="salesChannelServices.showNewEditChannel"
        [style]="{ width: '40%' }"
        modal="true"
    >
        <app-bizz-sales-channel-form
            [singupBusinessConfig]="true"
            [isNew]="true"
            [isViewOnly]="false"
            (onSubmit)="refrestDataList($event)"
        ></app-bizz-sales-channel-form>
    </p-dialog>
</ng-container>

<!-- Assign Coupon Dialog -->
<p-dialog
    header="Assign Coupons"
    [(visible)]="showAssignCouponDialog"
    [style]="{ width: '100%', maxWidth: '420px' }"
    [modal]="true"
    [dismissableMask]="true"
    [closable]="false"
>
    <div class="p-fluid">
        <!-- Search Field -->
        <div class="mb-3">
            <div class="flex align-items-center gap-2 w-full">
                <span
                    class="p-inputgroup-addon flex align-items-center justify-content-center bg-white"
                    style="width: 40px"
                >
                    <i class="pi pi-search text-600"></i>
                </span>

                <div class="relative w-full">
                    <p-autoComplete
                        #couponAuto
                        [(ngModel)]="selectedCoupon"
                        [suggestions]="filteredCoupons"
                        (completeMethod)="filterCoupons($event)"
                        field="name"
                        placeholder="Search or select coupon"
                        [dropdown]="true"
                        [forceSelection]="true"
                        appendTo="body"
                        (onSelect)="addCoupon($event, couponAuto)"
                        class="w-full"
                        inputStyleClass="w-full pr-8"
                           [panelStyle]="{ 'z-index': '1500' }"
                    >
                        <ng-template let-coupon pTemplate="item">
                            <div
                                class="flex align-items-center justify-content-between w-full"
                                [ngClass]="{
                                    'opacity-50 pointer-events-none':
                                        coupon.disabled
                                }"
                            >
                                <span>{{ coupon.name }}</span>
                                <small
                                    *ngIf="coupon.disabled"
                                    class="text-gray-500"
                                    >(Selected)</small
                                >
                            </div>
                        </ng-template>
                    </p-autoComplete>
                </div>
            </div>
        </div>

        <!-- Table for Assigned Coupons -->
        <p-table
            [value]="assignedCoupons"
            responsiveLayout="scroll"
            styleClass="p-datatable-sm custom-coupon-table"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 40px; text-align: center">#</th>
                    <th>Coupon</th>
                    <th style="width: 60px; text-align: center">Remove</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-i="rowIndex">
                <tr>
                    <td style="text-align: center">{{ i + 1 }}</td>
                    <td class="text-700 font-medium">{{ rowData.name }}</td>
                    <td style="text-align: center">
                        <button
                            pButton
                            icon="pi pi-times"
                            class="p-button-rounded p-button-text text-red-500 hover:text-red-600"
                            (click)="removeCoupon(i)"
                        ></button>
                    </td>
                </tr>
            </ng-template>
            <!-- Empty Message -->
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3" class="text-center py-4">
                        <div
                            class="flex flex-column align-items-center justify-content-center text-gray-600"
                        >
                            <i
                                class="pi pi-ticket text-3xl text-orange-500 mb-2"
                            ></i>
                            <span class="text-sm font-medium"
                                >No coupons assigned yet</span
                            >
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <!-- Footer Buttons -->
        <div
            class="assign-footer flex justify-between align-items-center mt-4 pt-3 border-top-1 surface-border"
        >
            <!-- Summary Section -->
            <div class="summary flex align-items-center gap-3 pl-2">
                <span class="text-sm text-gray-600">
                    <i class="pi pi-plus-circle text-green-500 mr-1"></i>
                    Added:
                    <b class="text-green-600">{{ addedCoupons.length }}</b>
                </span>
                <span class="text-sm text-gray-600">
                    <i class="pi pi-minus-circle text-red-500 mr-1"></i>
                    Removed:
                    <b class="text-red-600">{{ removedCoupons.length }}</b>
                </span>
            </div>

            <!-- Action Buttons -->
            <div class="actions flex align-items-center gap-2 pr-1">
                <button
                    pButton
                    label="Cancel"
                    class="p-button-text text-gray-700 hover:text-gray-900 font-medium"
                    (click)="cancelAssignCouponDialog()"
                ></button>
                <button
                    pButton
                    label="Save"
                    class="p-button font-medium"
                    style="
                        background-color: #ff5722;
                        border: none;
                        padding: 0.6rem 1.5rem;
                    "
                    (click)="saveAssignedCoupons()"
                ></button>
            </div>
        </div>
    </div>
</p-dialog>
<p-dialog
    header="Assigned Coupons"
    [(visible)]="showAllCouponsDialog"
    [modal]="true"
    [style]="{ width: '350px' }"
>
    <div *ngIf="selectedCoupons?.length; else noCoupons" class="p-fluid">
        <ul class="list-none m-0 p-0">
            <li
                *ngFor="let c of selectedCoupons; let i = index"
                class="flex align-items-center justify-content-between border-bottom-1 surface-border py-2"
            >
                <span>{{ i + 1 }}. {{ c.couponCode }}</span>
            </li>
        </ul>
    </div>

    <ng-template #noCoupons>
        <div class="text-center py-3 text-gray-600">No coupons assigned</div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button
            pButton
            label="Close"
            class="p-button-text"
            (click)="showAllCouponsDialog = false"
        ></button>
    </ng-template>
</p-dialog>
